import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv2010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv2010SearchParams = z.infer<typeof Inv2010SearchParamsSchema>

export const Inv2010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isFulfilled: z.boolean().nullish(),
})

export type Inv2010SearchResultModel = z.infer<
  typeof Inv2010SearchResultModelSchema
>

export const Inv2010SearchResultSchema = z
  .object({
    data: z.array(Inv2010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv2010SearchResult = z.infer<typeof Inv2010SearchResultSchema>
